// extracted by mini-css-extract-plugin
export default {"container":"review_container__-Id2s","name":"review_name__B9J8S","date":"review_date__XDnaE","text":"review_text__pcM8k"};